module.exports = __webpack_public_path__ + "static/media/matthieu.127fb093.png";